import { useState } from 'react';
import './GPUResults.css';

function GPUResultsRow(props) {
  const [clicked, setClicked] = useState(false);

  const showValue = (value) => value || 'N/A';
  const metrics = props.selectedGPU === 'Any'
    ? [
        ['GPU', props.resultElement.gpu_name],
        ['Power', props.resultElement.power],
        ['CPU', props.resultElement.cpu_used],
        ['C-Level', props.resultElement.c_level],
        ['Difficulty', props.resultElement.difficulty],
        ['Max Size (PiB)', props.resultElement.max_farm_size]
      ]
    : [
        ['Power', props.resultElement.power],
        ['CPU', props.resultElement.cpu_used],
        ['C-Level', props.resultElement.c_level],
        ['Difficulty', props.resultElement.difficulty],
        ['Max Size (PiB)', props.resultElement.max_farm_size]
      ];

  return (
    <article className="GPUResultsCard">
      <button
        type="button"
        className="GPUResultsRow"
        onClick={() => setClicked((value) => !value)}
        aria-expanded={clicked}
      >
        {metrics.map(([label, value]) => (
          <span className="GPUResultsMetric" key={label}>
            <span className="GPUResultsMetricLabel">{label}</span>
            <span>{showValue(value)}</span>
          </span>
        ))}
      </button>
      {clicked ? 
        <div className='GPUResultsExtraInformation'>
          <p>Version: {showValue(props.resultElement.giga_version)}</p>
          <p>OS: {showValue(props.resultElement.operating_system)}</p>
          <p>Threads: {showValue(props.resultElement.thread_count)}</p>
          <p>User: {showValue(props.resultElement.user)}</p>
          <p>Information: {showValue(props.resultElement.information)}</p>
        </div>
        :
        null
      }
    </article>
  );
}

export default GPUResultsRow;
